import { base64ToString, stringToBase64 } from '../base64/base64';
import { IImageResize } from '../types';

function getImageSecret() {
  const secret = process.env.MIXER_SECRET || '';
  if (!secret) {
    throw 'getImageSecret MIXER_SECRET not defined';
  }
  return secret;
}

function textToArrayBuffer_(text: string) {
  const encoder = new TextEncoder();
  const arrayBuffer = encoder.encode(text);
  return arrayBuffer;
}

function arrayBufferToText_(arrayBuffer: ReturnType<typeof textToArrayBuffer_>): string {
  const encoder = new TextDecoder('utf-8');
  const text = encoder.decode(arrayBuffer);
  return text;
}

function xor_(text: string, secret: string) {
  const s = textToArrayBuffer_(secret);
  const t = textToArrayBuffer_(text);
  const m = t.map((a, i) => {
    const b = s[i % s.length]!;
    return a ^ b;
  });
  return arrayBufferToText_(m);
}

function encrypt_(text: string, secret: string) {
  const encrypted = xor_(text, secret);
  // console.log('encrypted', encrypted);
  const base64 = stringToBase64(encrypted);
  return base64;
}

function decrypt_(base64: string, secret: string) {
  const text = base64ToString(base64);
  const decrypted = xor_(text, secret);
  // console.log('decrypted', decrypted);
  return decrypted;
}

export function encryptImageToken(imageResize: IImageResize): string {
  const text = JSON.stringify(imageResize);
  const token = encrypt_(text, getImageSecret());
  // console.log('encryptImageToken.token', token);
  return token;
}

export function decryptImageResize(token: string): IImageResize {
  // console.log('decryptImageResize.token', token);
  const text = decrypt_(token, getImageSecret());
  const data = JSON.parse(text);
  // console.log('decryptImageResize.data', data);
  return data;
}

/*
function encodeURIComponentRFC3986(text: string): string {
  return encodeURIComponent(text).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`);
}
*/

